import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  locationsContainer: {
    height: '100%',
    position: 'relative'
  },

  header: {
    display: 'block',
    width: '100%',
    alignItems: 'center',

    '@media (min-width:356px)': {
      display: 'inline-flex'
    }
  },

  headerContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  headerBtnContainer: {
    display: 'flex',
    paddingLeft: 16,
    gap: 10,

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap',
      width: '100%',
      flexDirection: 'column'
    }
  },

  content: {
    height: '100%'
  },

  noDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: 16,

    '& span': {
      fontSize: 18,
      fontWeight: 600,
      color: theme.palette.primary.main
    }
  },
  noDataCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    width: '100%'
  },
  noDataText: {
    color: theme.palette.primary.main,
    fontSize: '0.8rem',
    fontWeight: 400,
    letterSpacing: '0.5px',
    borderRadius: '12px',
    padding: '24px 32px',
    textAlign: 'center',
    marginTop: '24px'
  }
}))
